import { ArdoqId, APIScenarioAttributes } from '@ardoq/api-types';
import { scenarios$ } from 'streams/scenarios/scenarios$';

const getScenarioById = (id: ArdoqId | null): APIScenarioAttributes | null =>
  id ? scenarios$.state.byId[id] : null;

const getScenarioNameById = (id: ArdoqId | null): string | undefined =>
  getScenarioById(id)?.name;

const exists = (id: ArdoqId | null): boolean => Boolean(getScenarioById(id));

const getScopeAndBranchId = (scenarioId: ArdoqId | null | undefined) => {
  const { scopeId, branchId } = (scenarioId && getScenarioById(scenarioId)) || {
    scopeId: null,
    branchId: null,
  };
  return { scopeId, branchId };
};

/**
 * `scenarioInterface` snapshots `scenarios$.state` at call time.
 *
 * The app is stream-based now. Join `scenarios$`
 * (`streams/scenarios/scenarios$.ts`, emitting `{ list, byId }`) -- or
 * `activeScenario$` (`streams/activeScenario/activeScenario$.ts`) when you need
 * the active one -- at a permitted boundary and thread the resolved scenario
 * downstream as plain parameters. Pure logic belongs in
 * `activeScenarioOperations` (`@ardoq/core`).
 *
 * Every member below is deprecated. See
 * `packages/eslint-plugin-ardoq-lint/docs/rules/no-model-interface-call.md`
 * for the hoisting recipe.
 */
export const scenarioInterface = {
  /**
   * @deprecated Read `scenarios$.byId[id]`.
   */
  getScenarioById,
  /**
   * @deprecated Join `activeScenario$` (`streams/activeScenario/activeScenario$.ts`) and call `activeScenarioOperations.getActiveScenarioId` (`@ardoq/core`).
   */
  getScopeAndBranchId,
  /**
   * @deprecated Read `scenarios$.byId[id]?.name`.
   */
  getScenarioNameById,
  /**
   * @deprecated Read `scenarios$.byId[id]` for presence.
   */
  exists,
};
